import * as React from "react";
import Button from "../../../Common/Buttons/Button";
import UserImg from "../../../Common/User/UserImg";

export type LoginUserType = {
    id: string;
    name: string;
    username: string;
    image: string;
};

type Props = {
    user: LoginUserType;
    onClick: (user: LoginUserType) => void;
    loggingIn?: boolean;
};

export default class LoginUser extends React.Component<Props> {
    public handleClick = (): void => {
        this.props.onClick(this.props.user);
    };

    public render(): React.ReactNode {
        return (
            <Button
                type="button"
                classes={[ "login-user" + (this.props.loggingIn ? " logging-in" : "") ]}
                onClick={this.handleClick}
                data-testid="sl-user"
            >
                <UserImg url={this.props.user.image} loading={this.props.loggingIn} />
                <p>{this.props.user.name}</p>
            </Button>
        );
    }
}
